<ion-app [class.has-sidebar]="showHeader">
  <app-sidebar
    *ngIf="showHeader"
    [userData]="userData"
    [smallScreen]="smallScreen"
    [currentLang]="currentLang">
  </app-sidebar>

  <ion-router-outlet></ion-router-outlet>


</ion-app>
